export default {
    REGISTER: 'register',
    SIGN_IN: 'sign-in',
    STATEFUL_REFRESH: 'stateful-refresh',
};
